module.exports = "<div class=\"jumbotron\">\r\n  <h2 class=\"display-3 text-warning\">Unauthorized</h2>\r\n  <p class=\"lead\">Sorry! You don't have the permission to access any modules in this application, please get more permission from the administrator or change the account and login again.</p>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Projects/ServiceChain/servicechain2/svc-ui/TRUNK/src/app/error/error.component.html
// module id = ../../../../../src/app/error/error.component.html
// module chunks = main